import { render, staticRenderFns } from "./CallsResolvedChart.vue?vue&type=template&id=50ca13c6"
import script from "./CallsResolvedChart.vue?vue&type=script&lang=js"
export * from "./CallsResolvedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports